import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import StatsStrip from "./components/StatsStrip";
import TopicWall from "./components/TopicWall";
import HeatRanking from "./components/HeatRanking";
import DeepAnalysis from "./components/DeepAnalysis";
import MotiveChain from "./components/MotiveChain";
import PeopleMap from "./components/PeopleMap";
import CompareBoard from "./components/CompareBoard";
import SubscribeCta from "./components/SubscribeCta";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <StatsStrip />
        <TopicWall />
        <HeatRanking />
        <DeepAnalysis />
        <MotiveChain />
        <PeopleMap />
        <CompareBoard />
        <SubscribeCta />
      </main>
      <SiteFooter />
    </div>
  );
}